export default __webpack_public_path__ + "static/media/marketplace-cx.f11858e9.png";